const N8N_BASE = 'https://n8n.isbet.org.br/webhook'
const N8N_TEST_BASE = 'https://n8n.isbet.org.br/webhook-test'

// Proxy pra API REST do n8n (execuções/workflows) — evita CORS e injeta a API key no servidor
// (dev: vue.config.js devServer.proxy; produção: nginx.conf.template). Nunca chamar a API do n8n direto do browser.
export const N8N_API_BASE = '/n8n-api'

/** Times/agentes do Chatwoot — usado por praticamente todas as views de gestão */
export const N8N_TEAMS_URL = `${N8N_BASE}/listar-times-chatwoot`

/** Workflow isolado "WootDash - MSG" (n8n/WootDash - MSG.json) — aviso em massa entre agentes */
export const N8N_BROADCAST_URL = `${N8N_BASE}/broadcast-agentes`

/** Workflow isolado "Atribuicao-chamado" (n8n/Atribuicao-chamado.json) — log/popup de atribuição de conversa (call_conv) */
export const N8N_CALL_CONV_URL = `${N8N_BASE}/atribuicao-chamado`

/** Workflow isolado "Sessoes-Agentes" (n8n/Sessoes-Agentes.json) — registro/heartbeat/revoke de sessões (Admin → Sessões, migração v30). Isolado do webhook compartilhado de propósito — mesmo motivo do N8N_CALL_CONV_URL acima. */
export const N8N_SESSIONS_URL = `${N8N_BASE}/agent-sessions`

/** Workflow isolado "Relatorio-Resolucao-Agendamento" (n8n/Relatorio-Resolucao-Agendamento.json) — agendamento por usuário + histórico de envios do Relatório de Resolução pro Slack (ver docs/planos/PLANO-AGENDAMENTO-ENVIO-SLACK-RELATORIO-RESOLUCAO.md). Isolado do webhook compartilhado de propósito — mesmo motivo do N8N_SESSIONS_URL acima. */
export const N8N_RESOLUTION_REPORT_SCHEDULE_URL = `${N8N_BASE}/resolution-report-schedule`

/** Workflow isolado "Notificacoes-Agentes" (n8n/Notificacoes-Agentes.json) — preferências de notificação (WhatsApp/e-mail) por agente + vínculo aviso→template (Admin, só perfil "Sistema"). Ver docs/planos/PLANO-NOTIFICACAO-WHATSAPP-EMAIL-AGENTES.md. Isolado do webhook compartilhado de propósito — mesmo motivo do N8N_SESSIONS_URL acima. */
export const N8N_AGENT_NOTIFICATIONS_URL = `${N8N_BASE}/notificacoes-agentes`

/** Workflow "Fila  Notificador - STATUS", webhook "Verificação Individual de Atribuição" (nós em n8n/Verificacao-Individual-Atribuicao-nodes.json) — disparado no login: atribui ao agente as conversas sem agente (pending/open) que ele pode atender, até a capacidade dele. */
export const N8N_INDIVIDUAL_ASSIGNMENT_URL = `${N8N_BASE}/verficacao-individual`

export const N8N_QUEUE_URL = `${N8N_BASE}/fila-queue`
export const N8N_UPLOAD_URL = `${N8N_BASE}/upload-arquivo-chat`
export const N8N_DOWNLOAD_URL = `${N8N_BASE}/download`

export const N8N_CHAT_WIDGET_URL =
  process.env.VUE_APP_N8N_WEBHOOK || `${N8N_BASE}/5c37fd86-6e8b-4385-9cbb-5d785b67966d`

export const N8N_LOGIN_URL = `${N8N_BASE}/5e40a8d3-dc3d-465c-b113-68ab24709f4d`
export const N8N_LOGIN_TEST_URL = `${N8N_TEST_BASE}/5e40a8d3-dc3d-465c-b113-68ab24709f4d`

export function n8nDownloadUrl(fileKey: string): string {
  return `${N8N_DOWNLOAD_URL}?fileKey=${fileKey}`
}
